import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ResetPasswordFunc } from '../../redux/Slices/AuthSlice'
import notify from '../UseNotification'
import { useNavigate } from 'react-router-dom'

const UseResetPassword = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [password, setPassword] = useState()
    const [confirmPassword, setConfirmPassword] = useState()
    const [loading, setLoading] = useState()
    const [isPress, setIsPress] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)
    const { ResetPassword } = useSelector(state => state.AuthReducer)

    // handle change password
    const onChangePassword = (e) => {
        setPassword(e.target.value)
    }

    // handle confirm password
    const onChangeConfirmPassword = (e) => {
        setConfirmPassword(e.target.value)
    }

    // handle validate Password 
    const validatePassword = (e) => {
        if (e.target.value.length < 6) {
            notify("password at least 6 character", "error")
        }
    }

    // handle validate confirm Password 
    const validateConfirmPassword = (e) => {
        if (e.target.value.length < 6) {
            notify("password at least 6 character", "error")
        } else if (confirmPassword != password) {
            notify("password not matched", "error")
        }
    }

    // to handle disbale submit button
    useEffect(() => {
        if (password && confirmPassword && password.length >= 6 && password === confirmPassword) {
            setIsFormValid(true)
        }else {
            setIsFormValid(false)
        }
    }, [password, confirmPassword])


    // handle submit
    const Submit = async () => {
        setIsPress(true)
        setLoading(true)
        await dispatch(ResetPasswordFunc({
            email: localStorage.getItem("email"),
            newPassword: password
        }))
        setLoading(false)
    }

    // handle response after dispatch request 
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (ResetPassword) {
                if (ResetPassword.status === 200) {
                    notify("Password changed", "success")
                    navigate("/login")
                }
                else if (ResetPassword.response.status === 400) {
                    notify(ResetPassword.response.data.message, "error")
                }
                else if (ResetPassword.response.status === 500) {
                    notify(ResetPassword.response.data.message, "error")
                }
            }
        }
    }, [loading])
    return [password, onChangePassword, confirmPassword, onChangeConfirmPassword, Submit, isPress, loading, validateConfirmPassword, validatePassword,isFormValid]
}

export default UseResetPassword
